/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import { TRegionKey } from '@source/interface';
import { ICreateSellTicketResponse } from '@source/interface/sell';

import { SELL_FORM_INFO_PROPS } from '@source/pages/SellCar/types';
import B5 from '@source/services/B5';
import { IErrorResponse } from '@source/interface/apiResponse';

const sliceName = 'B5_INSPECTION';

// Todo: Init first
type B5_STATE_PROPS = {
  ticket: Record<string, any> | null;
  loading: boolean;
  optionsLoading: boolean;
  formInfo: SELL_FORM_INFO_PROPS;
};

const INITIAL_STATE: B5_STATE_PROPS = {
  ticket: null,
  loading: false,
  optionsLoading: false,
  formInfo: {
    formWrapperOriginalHeight: 560,
  },
};

export const createB5Ticket = createAsyncThunk<
  ICreateSellTicketResponse,
  { country: TRegionKey; payload: Record<string, any>; isAuthenticated: boolean },
  {
    rejectValue: IErrorResponse;
  }
>(
  `${sliceName}/createB5Ticket`,
  async (
    {
      country,
      payload,
      isAuthenticated,
    }: { country: TRegionKey; payload: Record<string, unknown>; isAuthenticated: boolean },
    { rejectWithValue },
  ) => {
    try {
      const res = await B5.createB5Ticket({ country, payload, isAuthenticated });

      return res.data;
      // Catch clause variable type annotation must be 'any' or 'unknown' if specified.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      const error: AxiosError<IErrorResponse> = err; // cast the error for access
      if (!error.response) throw err;
      return rejectWithValue(error.response.data);
    }
  },
);

const slice = createSlice({
  name: sliceName,
  initialState: INITIAL_STATE,
  reducers: {
    setFormInfo(state, { payload }) {
      const { key, value } = payload;
      state.formInfo = { ...current(state).formInfo, [key]: value };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createB5Ticket.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createB5Ticket.fulfilled, (state, { payload }) => {
      state.ticket = payload?.data;
      state.loading = false;
    });
    builder.addCase(createB5Ticket.rejected, (state) => {
      state.loading = false;
    });
  },
});

const { setFormInfo } = slice.actions;
export { setFormInfo };

export default slice.reducer;
